module.exports = __webpack_public_path__ + "img/05.60ac576a.jpg";